import NonCustomerCard from './NonCustomerCard';

export default NonCustomerCard;